import Routers from "./Routes";

const App = () => {
  return (
    <Routers/>
  );
}

export default App;
